import axios from "axios";
import { authHeader, authHeaderAsync } from "../helpers/auth-header";
import store from "../store/index"
import router from "@/router";

export const accountService = {
    async createAccount(account) {
            let response = await axios({
                method: "post",
                url: "/api/account",
                data: account,
                headers: await authHeaderAsync()
            });
            return response.data;
    },
    getLocalAccount() {
        return JSON.parse(localStorage.getItem("account"));
    },
    async updateAccount(account) {
        let response = await axios({
            method: "put",
            url: "/api/account",
            data: account,
            headers: await authHeaderAsync()
        });
        return response.data;
    },
    async deleteAccount(accountId) {
        let response = await axios({
                method: "delete",
                url: "/api/account/" + accountId,
                headers: authHeader()
            });
        return response.data;
    },
    forgotPassword(email) {
        return new Promise((resolve, reject) => {
            axios({
                method: "post",
                url: "/api/account/forgot?email=" + email,
            }).then(function (response) {
                resolve(response.data)
            }).catch(function (error) {
                reject(error)
            });
        })
    },
    resetPassword(token, newPassword) {
        return new Promise((resolve, reject) => {
            axios({
                method: "post",
                url: "/api/account/reset?token=" + token,
                data: {
                    "password": newPassword,
                }
            }).then(function (response) {
                resolve(response.data)
            }).catch(function (error) {
                reject(error)
            });
        })
    },
    async getUsers() {
            let response = await axios({
                method: "get",
                url: "/api/account/users",
                headers: await authHeaderAsync()});

            return response.data;
    },
    signOut() {
        store.commit("logout");
        router.push("signin")
    },
    refreshToken() {
        return new Promise(((resolve, reject) => {
            let refreshToken = localStorage.getItem("refresh_token")
            axios({
                method: "post",
                url: "/connect/token",
                headers: {
                    "content-type": "application/x-www-form-urlencoded",
                    "Authorization": "Basic YmVuZXZBcHBDbGllbnQ6c2VjcmV0"
                },
                data: "grant_type=refresh_token&client_id=benevAppClient&client_secret=secret&refresh_token="+refreshToken
            }).then((response) => {
                localStorage.setItem("token", response.data.access_token);
                localStorage.setItem("refresh_token", response.data.refresh_token)
                resolve("success")
            }).catch((error) => {
                reject(error)
            })
        }))
    },
    async getOrganisationalUnits() {
        try {
            let response = await axios({
                method: "get",
                url: "/api/organisationalunit",
                headers: await authHeaderAsync()
            });
            return response.data;
        } catch(error) {
            if (error.response.status === 401) {
                throw Error(error.response.data);
            }
            throw error;
        }
    },
    signIn(email, password) {
        return new Promise((resolve, reject) => {

            axios({
                method: "post",
                url: "/connect/token",
                headers: {
                    "content-type": "application/x-www-form-urlencoded",
                    "Authorization": "Basic YmVuZXZBcHBDbGllbnQ6c2VjcmV0"
                },
                data: "grant_type=password&username=" + email + "&password=" + password + "&scope=BenevAppApi offline_access&client_id=benevAppClient&client_secret=secret"
            }).then((response) => {
                localStorage.setItem("token", response.data.access_token);
                localStorage.setItem("refresh_token", response.data.refresh_token)
                axios({
                    method: "get",
                    url: "/api/account/me",
                    headers: authHeader()
                }).then((response) => {
                    localStorage.setItem("account", JSON.stringify(response.data));
                    resolve("success");
                }).catch((error) => {
                    reject(error)
                })
            }).catch((error) => {
                if(error.response.status === 400)
                    reject(error.response.data.error_description)
                console.log(error);
                reject(error)
            })

            /*axios.post("/api/account/signin", {
                Email: email,
                Password: password
            }).then((response) => {
                localStorage.setItem("account", JSON.stringify(response.data.account));
                localStorage.setItem("token", response.data.token);
                resolve("success")
            }).catch(function (error) {
                console.log(error);
                if(error.response.status === 401) {
                    reject(error.response.data)
                } else {
                    reject("Ein unbekannter Fehler ist aufgetreten.")
                }
            })*/
        });
    },
    async getRoles() {
        let response = await axios({
                method: "get",
                url: "/api/role",
                headers: await authHeaderAsync()
            });
        return response.data;
    },
    async getQuery(query) {
        let response = await axios({
            method: "get",
            url: "/api/account/filter?" + query,
            headers: await authHeaderAsync()
        });
        return response.data;
    },
    verifyEmail(token) {
        return new Promise((resolve, reject) => {
            axios({
                method: "get",
                url: "/api/account/verify?token=" + token,
                headers: authHeader()
            }).then(function (response) {
                resolve(response.data)
            }).catch(function (error) {
                reject(error.data)
            });
        })
    }
}